import ChallengesRow from './ChallengesRow';

export default ChallengesRow;
